const SOUND_PREFERENCE_KEY = 'wlearn-sound-enabled'
const LEGACY_MUSIC_PREFERENCE_KEY = 'wlearn-adventure-music-enabled'

const soundPlayers = new Map<string, HTMLAudioElement>()

export function useSound() {
  const isSoundEnabled = useState('sound-enabled', () => true)
  const hasLoadedSoundPreference = useState(
    'sound-preference-loaded',
    () => false,
  )

  function initializeSoundPreference() {
    if (!import.meta.client || hasLoadedSoundPreference.value) return

    const savedPreference =
      localStorage.getItem(SOUND_PREFERENCE_KEY) ??
      localStorage.getItem(LEGACY_MUSIC_PREFERENCE_KEY)

    if (savedPreference !== null) {
      isSoundEnabled.value = savedPreference === 'true'
    }

    hasLoadedSoundPreference.value = true
  }

  function setSoundEnabled(enabled: boolean) {
    isSoundEnabled.value = enabled
    if (!enabled) {
      for (const player of soundPlayers.values()) {
        player.pause()
        player.currentTime = 0
      }
    }
    if (import.meta.client) {
      localStorage.setItem(SOUND_PREFERENCE_KEY, String(enabled))
    }
  }

  function toggleSound() {
    setSoundEnabled(!isSoundEnabled.value)
  }

  function playSound(src: string, volume: number) {
    if (!import.meta.client || !isSoundEnabled.value) return

    let player = soundPlayers.get(src)
    if (!player) {
      player = new Audio(src)
      player.preload = 'auto'
      soundPlayers.set(src, player)
    }

    player.volume = volume
    player.currentTime = 0
    void player.play().catch(() => {
      // A browser may block audio until the learner has interacted with the page.
    })
  }

  function playSelectSound() {
    playSound('/audio/ui/select-click.wav', 0.55)
  }

  function playCorrectAnswerSound() {
    playSound('/audio/ui/correct-answer.wav', 0.7)
  }

  function playIncorrectAnswerSound() {
    playSound('/audio/ui/incorrect-answer.mp3', 0.7)
  }

  function playLevelCompleteSound() {
    playSound('/audio/adventure/level-complete.mp3', 0.78)
  }

  function playAdventureCompleteSound() {
    playSound('/audio/adventure/adventure-complete.mp3', 0.82)
  }

  return {
    isSoundEnabled: readonly(isSoundEnabled),
    initializeSoundPreference,
    setSoundEnabled,
    toggleSound,
    playSelectSound,
    playCorrectAnswerSound,
    playIncorrectAnswerSound,
    playLevelCompleteSound,
    playAdventureCompleteSound,
  }
}
